import React, { Component } from 'react';

import './App.css';
import 'tachyons';

import Login from './components/Login/Login';
import DashBoard from './components/DashBoard/DashBoard';


class Supervisor extends Component {
constructor(props){
  super(props);

  this.state ={
    isLogedIn:false,

  }
}

Login = (val) =>{
  this.setState({isLogedIn:val});
}



  render() {

    return (
      <div className="App">
      <header className="App-header shadow-3">

        <h1 className="App-title">Fetch My Kid School</h1>
        <span>  Version 01.alpha.01  by Apps Design &copy;</span>
      </header>
<div style={{marginTop:200}}>
    { !this.state.isLogedIn ?

    < Login isLogedIn={this.Login.bind(this)}/>

      : <DashBoard isLogedIn={this.Login.bind(this)}/>

       }
</div>


      </div>

    );
  }
}

export default Supervisor;


//Login -> done

//Logout

//add assistant

//Reports ( daily report, child detail, export data )

//Data uploads (
//upload list , add collector, add child , add class,
// select child -> change child => create barcodes
// select class -> change class => create barcodes
// select collector -> change collector => create barcodes
//)



// WEBPACK FOOTER //
// ./src/Supervisor.js